import { Children, cloneElement } from 'react';
import cx from 'classnames';
import { filterDataProps } from '@THC/utils/helpers';
import styles from './Icon.module.scss';
export const Icon = (props) => {
    const { children, direction, filled = true, id, size } = props;
    const child = Children.only(children);
    return cloneElement(child, {
        'aria-hidden': props['aria-hidden'] ?? true,
        'aria-label': props['aria-label'],
        className: cx(styles.icon, styles[size], styles[direction]),
        'data-filled': filled,
        id,
        role: 'img',
        ...filterDataProps(props),
    });
};
